// extracted by mini-css-extract-plugin
export default {"root":"AddClientsModal_root__z3T2z","buttonGroup":"AddClientsModal_buttonGroup__KvhNs","modalHeader":"AddClientsModal_modalHeader__fZQHw"};